import {ExpandContent} from './expandContent'

export {ExpandContent}
